// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//     this.setHeaderCartIconAccessibility();
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector('#cart-icon-bubble');
//     if (!cartLink) return;

//     cartLink.setAttribute('role', 'button');
//     cartLink.setAttribute('aria-haspopup', 'dialog');
//     cartLink.addEventListener('click', (event) => {
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener('keydown', (event) => {
//       if (event.code.toUpperCase() === 'SPACE') {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
//     // here the animation doesn't seem to always get triggered. A timeout seem to help
//     setTimeout(() => {
//       this.classList.add('animate', 'active');
//     });

//     this.addEventListener(
//       'transitionend',
//       () => {
//         const containerToTrapFocusOn = this.classList.contains('is-empty')
//           ? this.querySelector('.drawer__inner-empty')
//           : document.getElementById('CartDrawer');
//         const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add('overflow-hidden');
//   }

//   close() {
//     this.classList.remove('active');
//     removeTrapFocus(this.activeElement);
//     document.body.classList.remove('overflow-hidden');
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute('role', 'button');
//     cartDrawerNote.setAttribute('aria-expanded', 'false');

//     if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
//       cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
//     }

//     cartDrawerNote.addEventListener('click', (event) => {
//       event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//     });

//     cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     this.querySelector('.drawer__inner').classList.contains('is-empty') &&
//       this.querySelector('.drawer__inner').classList.remove('is-empty');
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);

//       if (!sectionElement) return;
//       sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
//     });

//     setTimeout(() => {
//       this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//       this.open();
//     });
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-drawer',
//         selector: '#CartDrawer',
//       },
//       {
//         id: 'cart-icon-bubble',
//       },
//     ];
//   }

//   getSectionDOM(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-drawer', CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//     ];
//   }
// }

// customElements.define('cart-drawer-items', CartDrawerItems);




function getEmptyCartDrawerInnerHTML() {
  return `
    <div class="drawer__inner-empty">
      <div class="cart-drawer__warnings center">
        <div class="cart-drawer__empty-content">

          <h2 class="cart__empty-text other-title">
            Your cart is empty
          </h2>

          <button
            class="drawer__close"
            type="button"
            aria-label="Close"
            onclick="this.closest('cart-drawer').close()"
          >
            <span class="svg-wrapper">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M3 3L15 15M15 3L3 15"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </span>
          </button>

          <a
            href="/collections/all-gifts"
            class="button-style"
          >
            Continue shopping
          </a>

        </div>
      </div>
    </div>

    <div class="drawer__header">
      <h2 class="drawer__heading other-title">
        Your cart
      </h2>

      <button
        class="drawer__close"
        type="button"
        aria-label="Close"
        onclick="this.closest('cart-drawer').close()"
      >
        <span class="svg-wrapper">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M3 3L15 15M15 3L3 15"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </span>
      </button>
    </div>
  `;
}


function createEmptyCartDrawerInner() {
  const drawerInner = document.createElement('div');

  drawerInner.className =
    'drawer__inner gradient color-scheme-1';

  drawerInner.setAttribute('role', 'dialog');
  drawerInner.setAttribute('aria-modal', 'true');
  drawerInner.setAttribute('aria-label', 'Your cart');
  drawerInner.setAttribute('tabindex', '-1');

  drawerInner.innerHTML =
    getEmptyCartDrawerInnerHTML();

  return drawerInner;
}


class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        this.close();
      }
    });

    this.bindOverlay();
    this.setHeaderCartIconAccessibility();
  }


  bindOverlay() {
    const overlay =
      this.querySelector('#CartDrawer-Overlay');

    if (!overlay) return;

    if (overlay.dataset.cartDrawerBound === 'true') {
      return;
    }

    overlay.addEventListener(
      'click',
      this.close.bind(this)
    );

    overlay.dataset.cartDrawerBound = 'true';
  }


  removeEmptyCartFooter() {
    const cartDrawer =
      this.querySelector('#CartDrawer');

    if (!cartDrawer) return;

    cartDrawer
      .querySelectorAll('.drawer__footer')
      .forEach((footer) => {
        footer.remove();
      });
  }


  mountEmptyDrawer() {
    if (!this.classList.contains('is-empty')) {
      return;
    }

    const cartDrawer =
      this.querySelector('#CartDrawer');

    if (!cartDrawer) return;

    /*
      Important:
      when the last item is removed, the old
      populated footer can remain in the DOM.
      Empty cart must never show it.
    */
    this.removeEmptyCartFooter();

    /*
      If empty UI already exists, don't create
      another copy.
    */
    if (this.querySelector('.drawer__inner')) {
      return;
    }

    cartDrawer.appendChild(
      createEmptyCartDrawerInner()
    );
  }


  unmountEmptyDrawer() {
    if (!this.classList.contains('is-empty')) {
      return;
    }

    const drawerInner =
      this.querySelector('.drawer__inner');

    if (drawerInner) {
      drawerInner.remove();
    }

    this.removeEmptyCartFooter();
  }


  setHeaderCartIconAccessibility() {
    const cartLink =
      document.querySelector('#cart-icon-bubble');

    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute(
      'aria-haspopup',
      'dialog'
    );

    cartLink.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        this.open(cartLink);
      }
    );

    cartLink.addEventListener(
      'keydown',
      (event) => {
        if (
          event.code.toUpperCase() === 'SPACE'
        ) {
          event.preventDefault();
          this.open(cartLink);
        }
      }
    );
  }


  open(triggeredBy) {
    /*
      Empty-cart UI does not exist in the
      initial/server-rendered HTML.

      Create it only when cart is opened.
    */
    if (this.classList.contains('is-empty')) {
      this.mountEmptyDrawer();
    }

    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote =
      this.querySelector(
        '[id^="Details-"] summary'
      );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(
        cartDrawerNote
      );
    }

    setTimeout(() => {
      this.classList.add(
        'animate',
        'active'
      );
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains('is-empty')
            ? (
                this.querySelector(
                  '.drawer__inner-empty'
                ) ||
                this.querySelector(
                  '.drawer__inner'
                )
              )
            : document.getElementById(
                'CartDrawer'
              );

        const focusElement =
          this.querySelector(
            '.drawer__inner'
          ) ||
          this.querySelector(
            '.drawer__close'
          );

        if (
          containerToTrapFocusOn &&
          focusElement
        ) {
          trapFocus(
            containerToTrapFocusOn,
            focusElement
          );
        }
      },
      { once: true }
    );

    document.body.classList.add(
      'overflow-hidden'
    );
  }


  close() {
    this.classList.remove('active');

    removeTrapFocus(this.activeElement);

    document.body.classList.remove(
      'overflow-hidden'
    );

    /*
      When empty cart closes, remove its
      dynamically-created UI again.
    */
    if (this.classList.contains('is-empty')) {
      setTimeout(() => {
        this.unmountEmptyDrawer();
      }, 350);
    }
  }


  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute(
      'role',
      'button'
    );

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling
        .getAttribute('id')
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote
          .nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget
            .closest('details')
            .hasAttribute('open')
        );
      }
    );

    cartDrawerNote.parentElement
      .addEventListener(
        'keyup',
        onKeyUpEscape
      );
  }


  getReturnedCartState(html) {
    if (!html) return null;

    const doc =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );

    const returnedDrawer =
      doc.querySelector('cart-drawer');

    if (!returnedDrawer) {
      return null;
    }

    return returnedDrawer.classList.contains(
      'is-empty'
    );
  }


  renderContents(parsedState) {
    const returnedCartHTML =
      parsedState &&
      parsedState.sections
        ? parsedState.sections['cart-drawer']
        : null;

    let isEmpty =
      this.getReturnedCartState(
        returnedCartHTML
      );

    /*
      Fallback for responses that contain
      item_count but no usable cart-drawer
      section state.
    */
    if (
      isEmpty === null &&
      parsedState &&
      typeof parsedState.item_count === 'number'
    ) {
      isEmpty =
        parsedState.item_count === 0;
    }

    /*
      Add-to-cart response may not contain
      item_count. If a cart-drawer section was
      returned and it's not marked is-empty,
      cart is populated.
    */
    if (isEmpty === null) {
      isEmpty = false;
    }

    this.classList.toggle(
      'is-empty',
      isEmpty
    );

    this.productId =
      parsedState ? parsedState.id : null;

    this.getSectionsToRender()
      .forEach((section) => {
        if (
          !parsedState ||
          !parsedState.sections ||
          !parsedState.sections[section.id]
        ) {
          return;
        }

        const sectionElement =
          section.selector
            ? document.querySelector(
                section.selector
              )
            : document.getElementById(
                section.id
              );

        if (!sectionElement) return;

        sectionElement.innerHTML =
          this.getSectionInnerHTML(
            parsedState.sections[
              section.id
            ],
            section.selector
          );
      });

    /*
      #CartDrawer HTML replacement also
      replaces the overlay element.
    */
    this.bindOverlay();

    if (isEmpty) {
      this.removeEmptyCartFooter();
      this.mountEmptyDrawer();
    }

    setTimeout(() => {
      this.open();
    });
  }


  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) return '';

    const doc =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );

    const element =
      doc.querySelector(selector);

    return element
      ? element.innerHTML
      : '';
  }


  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }


  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) return null;

    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(selector);
  }


  setActiveElement(element) {
    this.activeElement = element;
  }
}


if (!customElements.get('cart-drawer')) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }


  /*
    CartItems calls this during remove /
    quantity updates.

    When cart becomes empty, server output
    intentionally has no .drawer__inner.
    Return our client-side empty UI and
    physically remove the old populated
    footer.
  */
  getSectionInnerHTML(
    html,
    selector
  ) {
    if (!html) return '';

    const doc =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );

    const element =
      doc.querySelector(selector);

    const cartDrawer =
      document.querySelector('cart-drawer');

    /*
      Special handling for cart drawer inner.
    */
    if (selector === '.drawer__inner') {
      if (!element) {
        /*
          Empty cart response:
          no .drawer__inner is server-rendered.
        */
        if (cartDrawer) {
          cartDrawer.classList.add('is-empty');

          const cartDrawerShell =
            cartDrawer.querySelector(
              '#CartDrawer'
            );

          if (cartDrawerShell) {
            cartDrawerShell
              .querySelectorAll(
                '.drawer__footer'
              )
              .forEach((footer) => {
                footer.remove();
              });
          }
        }

        return getEmptyCartDrawerInnerHTML();
      }

      /*
        Populated cart response.
      */
      if (cartDrawer) {
        cartDrawer.classList.remove(
          'is-empty'
        );
      }

      return element.innerHTML;
    }

    return element
      ? element.innerHTML
      : '';
  }
}


if (!customElements.get('cart-drawer-items')) {
  customElements.define(
    'cart-drawer-items',
    CartDrawerItems
  );
}